import AIDialog from '../commons/ai-dialog';
import Card from '../commons/card';
import { createElement } from 'react';
import { useCallback, useEffect, useState } from 'react';
import img from '../assets/imgs/gift@2x.png';
function CardImg(props) {
    const { answer = "恭喜你完成所有任务|请您联系网点服务人员领取奖励哦～", onComplete, pageData = {
        id: "AITaskDone"
    } } = props;
    const [msg, setMsg] = useState();
    const handleComplete = useCallback(() => {
        onComplete?.();
    }, []);
    useEffect(() => {
        const info = answer?.split('|') || [];
        setMsg({
            ...pageData,
            title: info[0] || '',
            message: info[1] || ''
        });
    }, []);
    return msg ? (createElement(Card, { title: msg.title, message: msg.message, img: createElement("img", { src: img, alt: "", width: "190" }), onComplete: handleComplete })) : (createElement(AIDialog, { type: "thinking" }));
}
export default CardImg;
